// src/api/botApi.js
import { apiFetch } from "../apiClient";

export function getBotSettings(userId) {
    return apiFetch(`/api/bot/settings?user_id=${encodeURIComponent(userId)}`);
}

export function updateBotSettings(userId, patch) {
    return apiFetch(`/api/bot/settings?user_id=${encodeURIComponent(userId)}`, {
        method: "POST",
        body: JSON.stringify({ user_id: userId, ...patch }),
    });
}

export function getBotStatus(userId) {
    return apiFetch(`/api/bot/status?user_id=${encodeURIComponent(userId)}`);
}

export function getBotLogs(userId, limit = 200) {
    return apiFetch(
        `/api/bot/logs?user_id=${encodeURIComponent(userId)}&limit=${limit}`
    );
}

export function runBotTick(userId) {
    return apiFetch(`/api/bot/run-tick`, {
        method: "POST",
        body: JSON.stringify({ user_id: userId }),
    });
}

export function killSwitch(userId, enabled = false) {
    return apiFetch(`/api/bot/kill-switch?user_id=${encodeURIComponent(userId)}`, {
        method: "POST",
        body: JSON.stringify({ user_id: userId, enabled }),
    });
}

export function refreshBotState(userId) {
    return apiFetch(`/api/bot/state/refresh?user_id=${encodeURIComponent(userId)}`, {
        method: "POST",
        body: JSON.stringify({ user_id: userId }),
    });
}

export function resetBotState(userId, clearPeak = false) {
    return apiFetch(`/api/bot/state/reset?user_id=${encodeURIComponent(userId)}`, {
        method: "POST",
        body: JSON.stringify({
            user_id: userId,
            clear_peak: clearPeak,
        }),
    });
}

export function runSmartExit(userId, { mode = "paper", execute = false, debug = true } = {}) {
    return apiFetch(`/api/bot/smart-exit?user_id=${encodeURIComponent(userId)}`, {
        method: "POST",
        body: JSON.stringify({ user_id: userId, mode, execute, debug }),
    });
}
